import { action } from 'satcheljs';

export const onTeachingBubbleStartDateStatusChanged = action('onTeachingBubbleStatusChanged', (isVisible?: boolean) => ({ isVisible }));
export const onTeachingBubbleEndDateStatusChanged = action('onTeachingBubbleStatusChanged', (isVisible?: boolean) => ({ isVisible }));
